<template>
  <v-flex class="bucket-field">
    <v-layout row v-if="!embedded">
      <v-layout column>
        <h5 class=" ml-1 pa-1 caption">{{fieldLabel}}</h5>
        <input
          :ref="addressId"
          class="px-2 address-field"
          type="text"
          placeholder="Start Typing..."
          :value="address"/>
      </v-layout>
      <v-btn :class="`pr-2 pt-2 address-button`" small ripple icon  @click="clearAddress()"><v-icon>clear</v-icon></v-btn>
      <v-icon :class="`pa-2 address-icon`">search</v-icon>
    </v-layout>
    <v-layout row v-if="embedded">
      <v-layout column>
        <span class="ml-1 pt-2 caption text-truncate opacity-54">{{fieldLabel}}</span>
        <input
          :ref="addressId"
          class="pl-2 address-field-embedded"
          type="text"
          placeholder="Start Typing..."
          :value="address"/>
      </v-layout>
      <v-btn :class="`pt-1 address-button`" small ripple icon  @click="clearAddress()"><v-icon>clear</v-icon></v-btn>
      <v-icon :class="`pa-1 address-icon`">search</v-icon>
    </v-layout>
  </v-flex>
</template>

<script>
import Helpers from '@/helpers.js'
import gmaps from "@/gmaps.js"
import { mapState } from "vuex"

export default {
  data: () => {
    return {
      autocomplete: null
    }
  },
  props: {
    field: {
      type: Object
    },
    data: {
      type: Object
    },
    embedded: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number
    },
    gmapHelpers: {
      type: Object,
      default: function() {
        return gmaps
      }
    }
  },
  mounted() {
    if (!this.autocomplete) {
      this.init()
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.currentUser
    }),
    apiKey() {
      try {
        const attrs = JSON.parse(this.currentUser.account.lifeCycleCallbacks)
        const apiKey = attrs.params.google.places.apiKey
        return apiKey
      } catch (error) {
        console.log("API Key not found, using default")
        return "AIzaSyClXhrOdY3Pw9lLHAMojsVloOrowThgGek"
      } 
    },
    countryList() {
      try {
        const attrs = JSON.parse(this.currentUser.account.lifeCycleCallbacks)
        const countryList = attrs.params.google.places.countryList
        return countryList
      } catch {
        console.log("Country list not found, using default")
        return ["uk"]
      } 
    },
    addressClass() {
      return this.row >= 0 ? "embedded-address" : "address"
    },
    address: {
      get() {
        if (this.data !== undefined && this.data !== null) {
          if (this.data.name) {
            if (this.data.country) {
              return this.data.name + ", " + this.data.country
            } else {
              return this.data.name
            }
          } else {
            return this.data
          }
        } else {
          if (this.field.default_value !== undefined) {
            return this.field.default_value
          } else {
            return ""
          }
        }
      },
      set(newAddress) {
        if (newAddress && newAddress.name) {
          this.$emit('update-item', { field: this.field.name, data: newAddress, row: this.row })
          this.$emit("blurred", {
            field: this.field.name,
            data: newAddress,
            row: this.row
          })
        } else {
          if (newAddress === "clear") { // Ensures user selected to clear
            this.$emit('update-item', { field: this.field.name, data: null, row: this.row })
            this.$emit("blurred", {
              field: this.field.name,
              data: null,
              row: this.row
            })
          }
        }
      }
    },
    addressId() {
      return `${this.field.name}${this.row ? "_" + this.row : ""}_address`
    },
    fieldLabel() {
      return (this.field.display_name) ? this.field.display_name : Helpers.capitalizeRemoveUnderscores(this.field.name)
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) { readonly = this.field.readonly }
      return readonly
    },
    items () {
      return this.entries
    }
  },
  methods: {
    async init() {
      await this.gmapHelpers.init(this.apiKey)
      const options = { componentRestrictions: { country: this.countryList } }
      this.autocomplete = this.gmapHelpers.getAutoComplete(this.$refs[this.addressId], options)
      this.autocomplete.addListener('place_changed', () => {
        this.handlePlaceChanged()
      })
    },
    clearAddress() {
      this.address = "clear"
    },
    handlePlaceChanged() {
      const place = this.autocomplete.getPlace()
      if (Object.keys(place).length < 2) {
        return // No results
      }
      const returnData = {}

      if (place.name !== undefined && this.placeName) {
        this.autocompleteText = place.name
      } else if (place.formatted_address !== undefined) {
        this.autocompleteText = place.formatted_address
      }

      if (place.address_components !== undefined) {
        for (let i = 0; i < place.address_components.length; i += 1) {
          const addressType = place.address_components[i].types[0]
          if (place.address_components[addressType]) {
            returnData[addressType] = place.address_components[addressType]
          }
        }

        if (place.geometry) {
          returnData.latitude = place.geometry.location.lat()
          returnData.longitude = place.geometry.location.lng()
        }

        // additional fields
        returnData.name = place.formatted_address
        if (place.name) { returnData.name = place.formatted_address }
        if (place.address_components) { returnData.address_components = place.address_components }
        if (place.place_id) { returnData.place_id = place.place_id }
        this.address = returnData
      }
    }
  }
}
</script>

<style>
  textarea:focus, input:focus{
    outline: none;
  }
  .address-field {
    width: 92%;
  }
  .address-field-embedded {
    width: 100%;
  }
</style>
